import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { PermissionsPage } from '../../features/permissions/permissions-page';

export const Route = createFileRoute('/permissions/')({
  component: PermissionsRoute,
});

function PermissionsRoute() {
  const partnerId = usePartnerId();
  return <PermissionsPage partnerId={partnerId} />;
}
